import { get } from 'lodash'

import { ThesaurusTerm, TranslatedString } from '@skinsoft/types'

export const preferredTerm = (thesaurusTerm: ThesaurusTerm): TranslatedString | undefined | null =>
    get(thesaurusTerm, 'thesaurusTermCS.preferredTerm', null)

export const synonyms = (thesaurusTerm: ThesaurusTerm): TranslatedString[] | null | undefined => {
    return get(thesaurusTerm, 'thesaurusTermCS.synonyms')
} 

export const thesaurusRef = (thesaurusTerm: ThesaurusTerm) => {
    const ref = get(thesaurusTerm, 'thesaurusTermSkin.thesaurus', null)

    return (ref as any)?.ref ?? ref
}

export const isAlternativeTerm = (thesaurusTerm: ThesaurusTerm) =>
    get(thesaurusTerm, 'isAlternativeTerm', null)

export const genericTerm = (thesaurusTerm: ThesaurusTerm) =>
    get(thesaurusTerm, 'thesaurusTermSkin.genericTerm', null)

export const pathIds = (thesaurusTerm: ThesaurusTerm) => 
    get(thesaurusTerm, 'pathIds.value', get(thesaurusTerm, 'pathIds', ''))

export const isForUnimarc = (thesaurusTerm: ThesaurusTerm): boolean | null | undefined => {
    return get(thesaurusTerm, "thesaurusTermSkin.isForUnimarc")
}
